import { useCallback, useMemo, useState } from 'react';
import constate from '../../common/lib/constate';
import VideoService from '../service/VideoService';
import { useUserContext } from './UserContext';
function useLibrary() {
  // Videos
  const [selectedCard, setSelectedCard] = useState({});
  const { logFirebaseEvent } = useUserContext();

  const toggleSelectedCard = useCallback(
    video => {
      if (selectedCard[video.id]) {
        const selectedCardData = { ...selectedCard };
        delete selectedCardData[video.id];
        return setSelectedCard({
          ...selectedCardData,
        });
      }

      return setSelectedCard({
        ...selectedCard,
        [video.id]: video,
      });
    },
    [selectedCard]
  );

  const toggleSelectedAllCard = videos => {
    if (Object.keys(selectedCard).length) {
      return setSelectedCard({});
    }

    const result = videos.reduce((accum, video) => ({ ...accum, [video.id]: video }), {});
    return setSelectedCard(result);
  };

  const toggleUnselectCards = useCallback(() => {
    return setSelectedCard({});
  }, []);

  const toggleCopyLinkToClipboard = useCallback(() => {
    const uuid = Object.keys(selectedCard)[0];
    navigator.clipboard.writeText(VideoService.getShareURL(uuid));
    logFirebaseEvent('copy_link_cl', { story_id: uuid });
  }, [selectedCard]);

  const [isShareShow, setIsShareShow] = useState(false);
  const toggleShareShow = useCallback(() => {
    setIsShareShow(prevState => !prevState);
  }, [isShareShow]);

  const [isDownloadVideos, setIsDownloadVideos] = useState(false);
  const toggleDownloadSelectedVideos = useCallback(() => {
    setIsDownloadVideos(prevState => !prevState);
  }, [isDownloadVideos]);

  const [isDeleteVideos, setIsDeleteVideos] = useState(false);
  const toggleDeleteVideos = useCallback(() => {
    setIsDeleteVideos(prevState => !prevState);
  }, [isDeleteVideos]);

  const [isArchiveVideos, setIsArchiveVideos] = useState(false);
  const toggleArchiveVideos = useCallback(() => {
    setIsArchiveVideos(prevState => !prevState);
  }, [isArchiveVideos]);

  const [isRenameVideo, setIsRenameVideo] = useState(false);
  const toggleRenameVideo = useCallback(() => {
    setIsRenameVideo(prevState => !prevState);
  }, [isRenameVideo]);

  const [isDuplicateVideo, setIsDuplicateVideo] = useState(false);
  const toggleDuplicateVideo = useCallback(() => {
    setIsDuplicateVideo(prevState => !prevState);
  }, [isDuplicateVideo]);

  const [showRecordingActions, setShowRecordingActions] = useState(false);

  const enableShowRecordingActions = useCallback(() => {
    setShowRecordingActions(true);
  }, []);

  const disableShowRecordingActions = useCallback(() => {
    setShowRecordingActions(false);
  }, []);

  const [showCreateFolderActions, setShowCreateFolderActions] = useState(false);
  const toggleShowCreateFolderActions = useCallback(() => {
    setShowCreateFolderActions(prevState => !prevState);
  }, [showCreateFolderActions]);

  const [isUnarchiveVideos, setIsUnarchiveVideos] = useState(false);
  const toggleUnarchive = useCallback(() => {
    setIsUnarchiveVideos(prevState => !prevState);
  }, [isUnarchiveVideos]);

  const [isMoveVideos, setIsMoveVideos] = useState(false);
  const toggleMoveVideos = useCallback(() => {
    console.log('Will toggle move videos', isMoveVideos);
    setIsMoveVideos(prevState => !prevState);
  }, [isMoveVideos]);

  // Folders
  const [selectedFolder, setSelectedFolder] = useState({});
  const toggleSelectedFolder = useCallback(
    folder => {
      if (selectedFolder[folder.id]) {
        const selectedFolderData = { ...selectedFolder };
        delete selectedFolderData[folder.id];
        return setSelectedFolder({
          ...selectedFolderData,
        });
      }

      return setSelectedFolder({
        ...selectedFolder,
        [folder.id]: folder,
      });
    },
    [selectedFolder]
  );

  const toggleUnselectFolders = useCallback(() => {
    setSelectedFolder({});
  }, [setSelectedFolder]);

  const [isRenameFolder, setIsRenameFolder] = useState(false);
  const toggleRenameFolder = useCallback(() => {
    setIsRenameFolder(prevState => !prevState);
  }, [isRenameFolder]);

  const [isDeleteFolders, setIsDeleteFolders] = useState(false);
  const toggleDeleteFolders = useCallback(() => {
    setIsDeleteFolders(prevState => !prevState);
  }, [isDeleteFolders]);

  const [isArchiveFolders, setIsArchiveFolders] = useState(false);
  const toggleArchiveFolders = useCallback(() => {
    setIsArchiveFolders(prevState => !prevState);
  }, [isArchiveFolders]);

  const [isUnarchiveFolders, setIsUnarchiveFolders] = useState(false);
  const toggleUnarchiveFolders = useCallback(() => {
    setIsUnarchiveFolders(prevState => !prevState);
  }, [isUnarchiveFolders]);

  const [folderToMove, setFolderToMove] = useState({ id: '', name: '' });
  const updateFolderToMove = useCallback(
    (id, name) => {
      setFolderToMove({ id, name });
    },
    [folderToMove]
  );

  const [isApproveVideo, setIsApproveVideo] = useState(false);
  const toggleApproveVideo = useCallback(() => {
    return setIsApproveVideo(!isApproveVideo);
  }, [isApproveVideo]);

  const [isDeclineVideo, setIsDeclineVideo] = useState(false);
  const toggleDeclineVideo = useCallback(() => {
    return setIsDeclineVideo(!isDeclineVideo);
  }, [isDeclineVideo]);

  const [isRevokeVideo, setIsRevokeVideo] = useState(false);
  const toggleRevokeVideo = useCallback(() => {
    return setIsRevokeVideo(!isRevokeVideo);
  }, [isRevokeVideo]);

  const [isRemoveFromReviewVideo, setIsRemoveFromReviewVideo] = useState(false);
  const toggleRemoveFromReviewVideo = useCallback(() => {
    return setIsRemoveFromReviewVideo(!isRemoveFromReviewVideo);
  }, [isRemoveFromReviewVideo]);

  return useMemo(
    () => ({
      selectedCard,
      toggleSelectedCard,
      toggleSelectedAllCard,
      toggleUnselectCards,
      toggleCopyLinkToClipboard,
      isShareShow,
      toggleShareShow,
      isDownloadVideos,
      toggleDownloadSelectedVideos,
      isDeleteVideos,
      toggleDeleteVideos,
      isArchiveVideos,
      setIsArchiveVideos,
      toggleArchiveVideos,
      toggleRenameVideo,
      isRenameVideo,
      showRecordingActions,
      showCreateFolderActions,
      enableShowRecordingActions,
      disableShowRecordingActions,
      toggleShowCreateFolderActions,
      toggleUnarchive,
      isUnarchiveVideos,
      selectedFolder,
      isRenameFolder,
      toggleRenameFolder,
      toggleSelectedFolder,
      toggleUnselectFolders,
      isDeleteFolders,
      toggleDeleteFolders,
      isArchiveFolders,
      toggleArchiveFolders,
      isUnarchiveFolders,
      toggleUnarchiveFolders,
      isMoveVideos,
      toggleMoveVideos,
      folderToMove,
      updateFolderToMove,
      toggleDuplicateVideo,
      isDuplicateVideo,
      isApproveVideo,
      toggleApproveVideo,
      isDeclineVideo,
      toggleDeclineVideo,
      isRevokeVideo,
      toggleRevokeVideo,
      isRemoveFromReviewVideo,
      toggleRemoveFromReviewVideo,
    }),
    [
      selectedCard,
      toggleSelectedCard,
      toggleUnselectCards,
      toggleCopyLinkToClipboard,
      isShareShow,
      toggleShareShow,
      isDownloadVideos,
      toggleDownloadSelectedVideos,
      isDeleteVideos,
      toggleDeleteVideos,
      isArchiveVideos,
      toggleArchiveVideos,
      toggleRenameVideo,
      isRenameVideo,
      toggleSelectedAllCard,
      showRecordingActions,
      showCreateFolderActions,
      enableShowRecordingActions,
      disableShowRecordingActions,
      toggleShowCreateFolderActions,
      toggleUnarchive,
      selectedFolder,
      isRenameFolder,
      toggleRenameFolder,
      toggleSelectedFolder,
      toggleUnselectFolders,
      isDeleteFolders,
      toggleDeleteFolders,
      isArchiveFolders,
      toggleArchiveFolders,
      isUnarchiveFolders,
      toggleUnarchiveFolders,
      isMoveVideos,
      toggleMoveVideos,
      folderToMove,
      updateFolderToMove,
      folderToMove,
      toggleDuplicateVideo,
      isDuplicateVideo,
      isApproveVideo,
      toggleApproveVideo,
      isDeclineVideo,
      toggleDeclineVideo,
      isRevokeVideo,
      toggleRevokeVideo,
      isRemoveFromReviewVideo,
      toggleRemoveFromReviewVideo,
    ]
  );
}

export const useLibraryContext = constate(useLibrary);

const LibraryContext = {
  Provider: useLibraryContext.Provider,
};

export default LibraryContext;
